import { useEffect, useState } from "react";
import { api, formatAUD } from "@/lib/api";

export default function AdminOrders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/orders").then((r) => setOrders(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="admin-orders">
      <p className="eyebrow mb-3">Commerce</p>
      <h1 className="font-serif text-5xl font-light mb-10">Orders</h1>

      {loading ? <p className="eyebrow text-muted-foreground">Loading…</p> : orders.length === 0 ? (
        <div className="py-20 text-center">
          <h3 className="font-serif text-3xl italic font-light">No orders yet.</h3>
        </div>
      ) : (
        <div className="border-t border-border">
          {orders.map((o) => (
            <details key={o.id} className="border-b border-border py-5" data-testid={`order-${o.id}`}>
              <summary className="grid grid-cols-12 gap-4 items-center cursor-pointer list-none">
                <div className="col-span-3 eyebrow text-muted-foreground">{new Date(o.created_at).toLocaleString()}</div>
                <div className="col-span-3 text-xs font-mono text-muted-foreground truncate">{o.session_id}</div>
                <div className="col-span-2">
                  <span className={`eyebrow ${o.payment_status === "paid" ? "text-foreground" : "text-muted-foreground"}`}>
                    {o.payment_status}
                  </span>
                </div>
                <div className="col-span-2 text-sm">{o.customer_email || "—"}</div>
                <div className="col-span-2 text-sm tabular-nums text-right">{formatAUD(o.amount)}</div>
              </summary>
              <div className="mt-5 pl-0 pt-5 border-t border-border grid grid-cols-1 md:grid-cols-2 gap-6 text-sm">
                <div>
                  <p className="eyebrow mb-2">Items</p>
                  <ul className="space-y-1">
                    {(o.items || []).map((it, idx) => (
                      <li key={idx} className="flex justify-between">
                        <span>{it.title} <span className="text-muted-foreground">({it.size}) × {it.quantity}</span></span>
                        <span className="tabular-nums">{formatAUD(it.unit_price * it.quantity)}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                <div>
                  <p className="eyebrow mb-2">Details</p>
                  <p>Shipping: {formatAUD(o.shipping || 0)}</p>
                  <p>Total: {formatAUD(o.amount)}</p>
                  <p>Status: {o.status}</p>
                  <p>Payment status: {o.payment_status}</p>
                </div>
              </div>
            </details>
          ))}
        </div>
      )}
    </div>
  );
}
